import React from "react";

export interface ConfirmOptions {
  title?: string | React.ReactNode;
  body?: string | React.ReactNode;
  buttons?: React.ReactNode[];
  showBackdrop?: boolean;
  backdropClose?: boolean;
  showCloseButton?: boolean;
}

type ConfirmState = {
  visible: boolean;
  options: ConfirmOptions | null;
};

type Listener = (state: ConfirmState) => void;

class ConfirmManagerClass {
  private static instance: ConfirmManagerClass;
  private listeners: Listener[] = [];
  private state: ConfirmState = {
    visible: false,
    options: null,
  };

  private constructor() {}

  static getInstance(): ConfirmManagerClass {
    if (!ConfirmManagerClass.instance) {
      ConfirmManagerClass.instance = new ConfirmManagerClass();
    }
    return ConfirmManagerClass.instance;
  }

  /**
   * 확인 창이 떠 있는지(spec 2026-09-29 D-14). 상세 페이지가 좌우 화살표 룰 이동을 막는 데 쓴다 —
   * `state`가 private라 외부에서 볼 수 없어 공개 getter를 연다. 확인 창이 열린 채 화살표를 누르면
   * 아래 룰이 바뀌고 창은 옛 ruleId로 남는 문제(재추출·승인·반려 창 공통)를 이 값으로 차단한다.
   */
  isVisible(): boolean {
    return this.state.visible;
  }

  addListener(listener: Listener): void {
    this.listeners.push(listener);
  }

  removeListener(listener: Listener): void {
    this.listeners = this.listeners.filter((l) => l !== listener);
  }

  show(options: ConfirmOptions): void {
    const defaultOptions: ConfirmOptions = {
      title: "",
      body: "",
      buttons: null,
      showBackdrop: true,
      backdropClose: true,
      showCloseButton: true,
    };

    this.state = {
      visible: true,
      options: { ...defaultOptions, ...options },
    };
    this.notifyListeners();
  }

  hide(): void {
    this.state = {
      ...this.state,
      visible: false,
    };
    this.notifyListeners();
  }

  private notifyListeners(): void {
    this.listeners.forEach((listener) => listener(this.state));
  }
}

export const ConfirmManager = ConfirmManagerClass.getInstance();
